// extracted by mini-css-extract-plugin
export default {"page-title":"_Z0zVh","pageTitle":"_Z0zVh"};